import * as THREE from 'three';
import BaseMesh from './base-mesh';
import { scaleCarModel } from '@blade-sxp/map/utils/index';
class Car extends BaseMesh {
    carDirection = new THREE.Vector3(-1, 0, 0);
    constructor(data) {
        super(data);
        this.carInit(data);
    }
    carInit(data) {
        const { visible = true, opacity = 1 } = data;
        const { url: newUrl, width: newWdith, height: newHeight, points = [], direction } = data.renderProps;
        const { url } = this.props.renderProps;
        if (url) {
            this._createTexture(newUrl).then(({ texture, ratio, width: realWidth, height: realHeight }) => {
                this.material = new THREE.MeshBasicMaterial({
                    map: texture,
                    side: THREE.FrontSide,
                    transparent: true,
                    depthTest: false,
                    opacity
                });
                if (!newWdith && !newHeight) {
                    this.geometry = new THREE.PlaneGeometry(realWidth, realHeight); // 二维矩形平面
                }
                else if (!newWdith) {
                    this.geometry = new THREE.PlaneGeometry(newHeight * ratio, newHeight); // 二维矩形平面
                }
                else if (!newHeight) {
                    this.geometry = new THREE.PlaneGeometry(newWdith, newWdith / ratio); // 二维矩形平面
                }
                else {
                    this.geometry = new THREE.PlaneGeometry(newWdith, newHeight); // 二维矩形平面
                }
                // this.rotation.z = rotate;
                this.material.opacity = opacity;
                const vertices = points.map((item) => {
                    return { x: item[0], y: item[1], z: 0 };
                });
                vertices.pop();
                this.getCarRotate(this.carDirection, direction);
                const scale = scaleCarModel(vertices, newWdith, newHeight);
                this.scale.set(scale, scale, 1);
            }, () => {
                this.dispose();
            });
        }
        this.visible = visible;
        super.update(data);
    }
    update(data, isInit = false) { }
    _createTexture(url) {
        return new Promise((resolve, reject) => {
            const loader = new THREE.TextureLoader();
            loader.crossOrigin = 'Anonymous';
            loader.load(url, (texture) => {
                const width = texture.image.width;
                const height = texture.image.height;
                const ratio = width / height;
                // 去除黑边
                texture.minFilter = THREE.NearestFilter;
                texture.magFilter = THREE.NearestFilter;
                texture.needsUpdate = true;
                resolve({ texture, ratio, width, height });
            }, undefined, (err) => { reject(err); });
        });
    }
    getCarRotate(pic, target) {
        const normalVector = new THREE.Vector3();
        const _direction = new THREE.Vector3(target.x, target.y, 0);
        normalVector.crossVectors(pic, _direction);
        const isReverse = normalVector.z > 0;
        const angle = pic.angleTo(_direction);
        this.rotateZ(isReverse ? -angle : angle);
    }
    dispose() {
        super.dispose();
    }
    onClick() {
        super.onClick();
    }
}
export default Car;
